import { AlertCircle } from "lucide-react";

const ErrorState = ({ error, onRetry }) => {
  return (
    <div className="error-container">
      <AlertCircle size={48} />
      <h2>Failed to load gallery</h2>
      <p>{error}</p>
      <button onClick={onRetry}>Try again</button>
    </div>
  );
};

export default ErrorState;